import { Container } from 'components/Container';
import * as React from 'react';
import styles from './PlaceholderHeroCard.module.scss';
import { GridContainer, GridElement } from 'components/Grid';

export const PlaceholderHeroCard: React.FunctionComponent = () => (
  <div className={styles.root}>
    <Container>
      <GridContainer>
        <GridElement mobile={2} mobileLandscape={0} />

        <GridElement mobile={8} mobileLandscape={4} desktop={6}>
          <div className={styles.image} />
        </GridElement>

        <GridElement mobile={2} mobileLandscape={0} />

        <GridElement mobile={12} mobileLandscape={8}>
          <div className={styles.textContent}>
            <div className={styles.highlightLabel} />
            <div className={styles.title} />
            <div className={styles.description} />
            <div className={styles.control} />
          </div>
        </GridElement>
      </GridContainer>
    </Container>
  </div>
);
